import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-modal-contract-cancel',
  templateUrl: './modal-contract-cancel.component.html',
  styleUrls: ['./modal-contract-cancel.component.scss']
})
export class ModalContractCancelComponent implements OnInit {

  constructor(
  ) {

  }

  ngOnInit(): void {
  }

}
